// extracted by mini-css-extract-plugin
module.exports = {"icon-list-container":"_3nNixgI","iconListContainer":"_3nNixgI","icon":"_19NOJ_3"};